<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-alert class="mt-8" color="error" icon="error" text>
      {{ text }}
    </v-alert>
    <div slot="actions">
      <v-layout>
        <v-btn @click="$emit('confirm')" color="error">Yes, CONTINUE</v-btn>
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import request from "@/modules/request";
import ActionModal from "./ActionModal";

export default {
  name: "ConfirmActionModal",
  props: {
    text: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
  components: {
    ActionModal,
  },
  methods: {
    close() {
      this.$emit("update:confirmActionModal", false);
    },
  },
};
</script>
